import React from "react";
import { Link } from "react-router-dom";
import "./../styles/OnlineServicesEn.scss";

const OnlineServicesEn = () => {
  return (
    <>
      <header className="online-services-header-en"></header>
      <div className="breadcrumbz container-sm ">
        <ol>
        <li>
            <Link to="/">
            HomePage <span>&gt;</span>
            </Link>
        </li>
        <li>
            <Link to="/en/online-services">
                Online Services
            </Link>
        </li>
        </ol>
      </div>
      <div className="online-services-content-container-en container-sm">
        <div className="online-services-container-en">
          <div className="left-box-en">
              <a href="https://musteriportal.sankoenerji.com.tr/Login/IndexDefault" target="_blank">
                <img className="left-box-image-en"></img>
              </a>              
          </div>
          <div className="right-row-en">
            <div className="right-box-1-en">
                <a href="/en/activities/green-energy?q=1032">
                    <img className="right-box-1-image-en"></img>
                </a>
            </div>
            <div className="right-box-2-en">
                <a href="/en/activities/electricity-sales?q=1026">
                    <img className="right-box-2-image-en"></img>
                </a>                
            </div>
          </div>          
        </div>
      </div>
    </>
  );
};

export default OnlineServicesEn;
